import protobuf from "protobufjs";

import decodeProtocolBuffer from "src/modules/protocol-buffers/decodeProtocolBuffer";
import { decodeBase64 } from "src/modules/protocol-buffers";
import debug from "src/modules/debug-logger";

import protoRoot, { Type } from "./proto-root";
export { default } from "./proto-root";

// const protobuf = window.require("protobufjs");

function createCustomizationBuffer(payload) {
  const customization = Type.AvatarCustomization.create(payload);
  const buffer = Type.AvatarCustomization.encode(customization).finish();
  return buffer;
}

function encodeCustomizationToBase64(customizationBuffer) {
  return protobuf.util.base64.encode(
    customizationBuffer,
    0,
    customizationBuffer.length
  );
}

export function encodeDogCustomization(customization) {
  const BreedAppearance = protoRoot.lookupEnum(
    "dogCustomization.BreedAppearance"
  );

  const breedAppearance = customization.breedAppearance
    .replaceAll("-", "_")
    .toUpperCase();
  const avatarCustomization = Type.AvatarCustomization.create({
    breedAppearance: BreedAppearance.values[breedAppearance]
  });

  const customizationBuffer = createCustomizationBuffer(avatarCustomization);

  return encodeCustomizationToBase64(customizationBuffer);
}

export function decodeDogCustomization(base64EncodedCustomization) {
  const bufferCustomization = decodeBase64(base64EncodedCustomization);
  const decodedCustomization = decodeProtocolBuffer({
    typePath: "dogCustomization.AvatarCustomization",
    buffer: bufferCustomization,
    root: protoRoot
  });

  if (!decodedCustomization?.breedAppearance) {
    debug.protoBuffers("Received unrecognized breedAppearance");
    return "default";
  }
  const breedAppearance = decodedCustomization.breedAppearance
    .replaceAll("_", "-")
    .toLowerCase();
  return { breedAppearance };
}
